"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { CalendarClock } from "lucide-react";
import { useMemo } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useMediaQuery } from "@/hooks/use-media-query";
import { formatFreemiumTrialEndsInLabel } from "@/lib/services/tier/freemium-trial-time";
import { formatFreemiumTrialEndDate } from "@/lib/services/tier/tier-date-format";
import { cn } from "@/lib/utils";
type FreemiumTrialEndsInProps = {
  expiresAt: Date;
};
export function FreemiumTrialEndsIn(t0) {
  const $ = _c(16);
  const {
    expiresAt
  } = t0;
  const isDesktop = useMediaQuery("(min-width: 768px)");
  let t1;
  if ($[0] !== expiresAt) {
    t1 = formatFreemiumTrialEndsInLabel({
      expiresAt
    });
    $[0] = expiresAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const endsInLabel = t1;
  let t2;
  bb0: {
    if (isDesktop) {
      t2 = `Trial ends in ${endsInLabel}.`;
      break bb0;
    }
    t2 = `${endsInLabel}`;
  }
  const buttonText = t2;
  if (!endsInLabel) {
    return null;
  }
  let t3;
  if ($[2] !== expiresAt) {
    t3 = formatFreemiumTrialEndDate({
      expiresAt
    });
    $[2] = expiresAt;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const trialEndDateLabel = t3;
  const statusLabel = `Trial ends in ${endsInLabel}, on ${trialEndDateLabel}.`;
  const tooltipText = `Your trial ends on ${trialEndDateLabel}. Upgrade to Premium before then to keep full access.`;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("hidden h-7.5 items-center gap-2 border-border/40 border-r bg-transparent px-2 md:pr-1 md:flex");
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CalendarClock aria-hidden={true} className="size-3.5 shrink-0 text-muted-foreground" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== buttonText) {
    t6 = <span className="text-foreground text-xs leading-none">{buttonText}</span>;
    $[6] = buttonText;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== statusLabel || $[9] !== t6) {
    t7 = <TooltipTrigger asChild={true}><button aria-label={statusLabel} className={t4} type="button">{t5}{t6}</button></TooltipTrigger>;
    $[8] = statusLabel;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== tooltipText) {
    t8 = <TooltipContent className="max-w-64 text-pretty" side="bottom" sideOffset={6}><p>{tooltipText}</p></TooltipContent>;
    $[11] = tooltipText;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <Tooltip>{t7}{t8}</Tooltip>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}